import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import LoadMore from '@components/ui-components/load-more/load-more'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      newQuestionnaires: [],
      pagination: null,
      disableLoadMore: false,
    }
  },
  components: {
    'load-more-cmp': LoadMore,
  },
  methods: {
    setPagination() {
      setTimeout(() => {
        this.pagination = this.$root.convertTwigToJs('pagination', '.js-pagination-questionnaires')
      }, 100)
    },
  },
  mounted() {
    this.setPagination()
  },
  beforeRouteUpdate(to, from, next) {
    // если не loadMore
    if (!to.query.loadMore) {
      const path = to.path.replace(router.history.base, '')
      this.$root.setDataAnimateFalse()

      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          setTimeout(() => {
            this.template = data.data
            this.setPagination()
            this.newQuestionnaires = []
          }, 500)
        },
        () => {
          next('/404')
        }
      )
    } else {
      this.disableLoadMore = true
      let url =
        process.env.NODE_ENV !== 'production' ? 'questionnaires/index2.json' : to.path.substring(1).replace(router.history.base, '')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          this.newQuestionnaires = this.newQuestionnaires.concat(data.data.items)
          this.pagination = data.data.pagination
          this.disableLoadMore = false
          setTimeout(() => {
            onScrollAnimate()
          }, 10)
        },
        () => {
          this.disableLoadMore = false
          next('/404')
        }
      )
    }
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/questionnaires/index.js